"use strict";

var _slicedToArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ", ";\n  border-radius: ", ";\n  animation: ", " 0.25s linear;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding-left: ", "px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100% !important;\n  padding-top: ", ";\n  > * {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InnerGrid = void 0;

var icons_1 = require("@ant-design/icons");

var web_1 = require("@thesisedu/web");

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

var react_window_1 = require("react-window");

var styled_components_1 = require("styled-components");

var log_1 = require("../log");

var GridContext_1 = require("./GridContext");

var sections_1 = require("./sections");

var DefaultPlaceholder_1 = require("./web/DefaultPlaceholder");

var WindowScroller_1 = require("./web/WindowScroller");

var widths_1 = require("./widths");

var HEADER_CELL_HEIGHT = 20 + 30 + 20; // 20 addl header padding, 30 height of text, 20 underneath.

var COLUMN_WIDTH_SIZE = '@size-l';

function InnerGrid(_ref) {
  var width = _ref.width,
      itemHeight = _ref.itemHeight;
  var theme = react_1.default.useContext(web_1.StyledThemeContext);

  var _react_1$default$useC = react_1.default.useContext(GridContext_1.GridContext),
      items = _react_1$default$useC.items,
      loadingFresh = _react_1$default$useC.loadingFresh,
      empty = _react_1$default$useC.empty;

  var gutter = parseFloat(theme[COLUMN_WIDTH_SIZE].replace('px', ''));

  var _ref2 = (0, widths_1.getItemWidthAndColumns)(gutter, width || 0),
      itemWidth = _ref2.itemWidth,
      numColumns = _ref2.numColumns;

  var gridRef = react_1.default.useRef(null);
  react_1.default.useEffect(function () {
    if (gridRef.current) {
      (0, log_1.debug)('resetting grid heights');
      gridRef.current.resetAfterIndices({
        columnIndex: 0,
        rowIndex: 0,
        shouldForceUpdate: true
      });
    }
  }, [width, itemHeight]);

  if (loadingFresh) {
    return react_1.default.createElement(web_1.BlockSpin, null);
  } else if (!items.length && empty) {
    return empty;
  } else if (!items.length) {
    return react_1.default.createElement(antd_1.Empty, {
      description: 'No content found!'
    });
  } else {
    return react_1.default.createElement(WindowScroller_1.ReactWindowScroller, {
      isGrid: true
    }, function (_ref3) {
      var ref = _ref3.ref,
          outerRef = _ref3.outerRef,
          style = _ref3.style,
          onScroll = _ref3.onScroll;
      var numRows = (0, sections_1.getTotalRows)(numColumns, items);
      return react_1.default.createElement(GridContext_1.InnerGridContext.Provider, {
        value: {
          numColumns: numColumns,
          itemWidth: itemWidth,
          gutter: gutter
        }
      }, react_1.default.createElement(react_window_1.VariableSizeGrid, {
        columnCount: numColumns,
        columnWidth: function columnWidth(columnIndex) {
          if (columnIndex === 0) return itemWidth;else return itemWidth + gutter;
        },
        rowCount: numRows,
        rowHeight: function rowHeight(rowIndex) {
          if ((0, sections_1.getSectionHeaderForRow)(rowIndex, numColumns, items)) {
            return HEADER_CELL_HEIGHT;
          } else {
            return Array(numColumns).fill('').reduce(function (acc, _, columnIndex) {
              var item = (0, sections_1.getItem)(rowIndex, columnIndex, numColumns, items);
              return item ? Math.max(acc, itemHeight(itemWidth, item)) : acc;
            }, 0);
          }
        },
        height: window.innerHeight,
        width: width || 0,
        outerRef: outerRef,
        ref: (0, web_1.composeRefs)(ref, gridRef),
        onScroll: onScroll,
        style: style,
        children: GridCell
      }));
    });
  }
}

exports.InnerGrid = InnerGrid;
var GridCell = react_1.default.memo(function (props) {
  var _react_1$default$useC2 = react_1.default.useContext(GridContext_1.GridContext),
      items = _react_1$default$useC2.items;

  var _react_1$default$useC3 = react_1.default.useContext(GridContext_1.InnerGridContext),
      numColumns = _react_1$default$useC3.numColumns;

  var headerForSection = (0, sections_1.getSectionHeaderForRow)(props.rowIndex, numColumns, items);

  if (headerForSection) {
    if (props.columnIndex === 0) {
      return react_1.default.createElement(GridHeaderCell, {
        section: headerForSection,
        style: props.style
      });
    } else return null;
  } else {
    return react_1.default.createElement(GridItemCell, Object.assign({}, props));
  }
}, react_window_1.areEqual);
GridCell.displayName = 'GridCell';

function GridHeaderCell(_ref4) {
  var section = _ref4.section,
      style = _ref4.style;
  return react_1.default.createElement(HeaderCellContainer, {
    style: style
  }, react_1.default.createElement(web_1.H3Alternate, null, section.title));
}

var HeaderCellContainer = web_1.styled.div(_templateObject(), function (props) {
  return props.theme['@size-xm'];
});

function GridItemCell(_ref5) {
  var _this = this;

  var rowIndex = _ref5.rowIndex,
      columnIndex = _ref5.columnIndex,
      style = _ref5.style;

  var _react_1$default$useC4 = react_1.default.useContext(GridContext_1.GridContext),
      items = _react_1$default$useC4.items,
      ItemComponent = _react_1$default$useC4.renderItem,
      _react_1$default$useC5 = _react_1$default$useC4.placeholder,
      placeholder = _react_1$default$useC5 === void 0 ? react_1.default.createElement(DefaultPlaceholder_1.DefaultGridPlaceholder, null) : _react_1$default$useC5,
      onClick = _react_1$default$useC4.onClick;

  var _react_1$default$useC6 = react_1.default.useContext(GridContext_1.InnerGridContext),
      numColumns = _react_1$default$useC6.numColumns,
      gutter = _react_1$default$useC6.gutter;

  var item = (0, sections_1.getItem)(rowIndex, columnIndex, numColumns, items);
  return (0, web_1.usePlaceholder)({
    placeholder: react_1.default.createElement(CellContainer, {
      gutter: gutter,
      style: style,
      index: columnIndex
    }, placeholder),
    getChildren: react_1.default.useCallback(function () {
      if (item) {
        return react_1.default.createElement(CellContainer, {
          gutter: gutter,
          style: style,
          index: columnIndex
        }, react_1.default.createElement(CellClickWrapper, {
          onClick: onClick ? function () {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return onClick(item);

                    case 2:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));
          } : undefined
        }, react_1.default.createElement(ItemComponent, {
          item: item
        })));
      } else {
        return react_1.default.createElement(CellContainer, {
          gutter: gutter,
          style: style,
          index: columnIndex
        });
      }
    }, [columnIndex, rowIndex, item === null || item === void 0 ? void 0 : item.id, style])
  });
}

var CellContainer = web_1.styled.div(_templateObject2(), function (props) {
  return props.index === 0 ? 0 : props.gutter;
});

function CellClickWrapper(_ref6) {
  var _this2 = this;

  var onClick = _ref6.onClick,
      children = _ref6.children;

  var _react_1$default$useS = react_1.default.useState(false),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      loading = _react_1$default$useS2[0],
      setLoading = _react_1$default$useS2[1];

  return react_1.default.createElement("div", {
    style: {
      position: 'relative'
    },
    onClick: !loading && onClick ? function () {
      return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                setLoading(true);
                _context2.prev = 1;
                _context2.next = 4;
                return onClick();

              case 4:
                _context2.next = 10;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](1);
                (0, log_1.error)('error in onClick handler for grid item');
                (0, log_1.error)(_context2.t0);

              case 10:
                _context2.prev = 10;
                setLoading(false);
                return _context2.finish(10);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 6, 10, 13]]);
      }));
    } : undefined
  }, children, loading ? react_1.default.createElement(LoadingOverlay, null, react_1.default.createElement(icons_1.LoadingOutlined, null)) : null);
}

var loadingEnter = (0, styled_components_1.keyframes)(_templateObject3());
var LoadingOverlay = (0, web_1.styled)(web_1.LightOverlay)(_templateObject4(), function (props) {
  return props.theme['@size-xl'];
}, function (props) {
  return props.theme['@border-radius-base'];
}, loadingEnter);